/** Kept in sync with assistant-ui `VELO_LOGIN_RETURN_KEY`. */
export const VELO_LOGIN_RETURN_KEY = 'velo.dashboard.loginReturnTo';

// Matches the TTL of the Velo sign-up state that assistant-ui keeps next to it.
const MAX_AGE_MS = 15 * 60 * 1000;

/**
 * Where to send a user whose Velo login failed at the oidc-client callback (which lands on this
 * app's login error page). Velo stores the page it started from; this opens Velo's login there.
 *
 * @returns {string|null} A same-origin `/guide` path with `authAction=login`, or null
 */
export function getVeloLoginReturnUrl() {
  try {
    const { returnTo, startedAt } = JSON.parse(sessionStorage.getItem(VELO_LOGIN_RETURN_KEY) ?? 'null') ?? {};
    if (typeof returnTo !== 'string') {
      return null;
    }
    if (typeof startedAt !== 'number' || Date.now() - startedAt > MAX_AGE_MS) {
      return null;
    }

    // Checked after parsing: `/guide/..//evil.com` resolves to the protocol-relative `//evil.com`.
    const url = new URL(returnTo, window.location.origin);
    const isVeloPath = url.pathname === '/guide' || url.pathname.startsWith('/guide/');
    if (url.origin !== window.location.origin || !isVeloPath) {
      return null;
    }
    url.searchParams.set('authAction', 'login');
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}
